import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

type FilterMapValue = string | ((value: string) => Record<string, unknown>);

interface UseDataTableStateOptions {
  filterMap?: Record<string, FilterMapValue>;
}

export const useDataTableState = ({
  filterMap = {},
}: UseDataTableStateOptions = {}) => {
  const [searchParams] = useSearchParams();

  const requestState = useMemo(() => {
    const state: Record<string, unknown> = {};

    // Handle pagination
    const page = searchParams.get('page');
    if (page) state.page = parseInt(page, 10);

    const pageSize = searchParams.get('pageSize');
    if (pageSize) state.pageSize = parseInt(pageSize, 10);

    // Handle sorting
    const orderBy = searchParams.get('orderBy');
    if (orderBy) state.orderBy = orderBy;

    const orderDirection = searchParams.get('orderDirection');
    if (orderDirection) state.orderDirection = orderDirection;

    // Handle custom filters using the filterMap
    for (const [key, value] of searchParams.entries()) {
      if (filterMap[key]) {
        const mapValue = filterMap[key];
        if (typeof mapValue === 'function') {
          Object.assign(state, mapValue(value));
        } else {
          state[mapValue] = value;
        }
      }
    }

    return state;
  }, [searchParams, filterMap]);

  return { requestState, searchParams };
};
